import { useSelector } from 'react-redux';
import { familyFeaturePreviewFree, familyFeaturePreviewPaid } from 'reactApp/appHelpers/featuresHelpers/features/familyFunctions';
import { getFamilyAlbumsFeature, getFamilyFoldersFeature } from 'reactApp/modules/family/family.selectors';
import { UserSelectors } from 'reactApp/modules/user/user.selectors';

export const useFamilyShowFeaturesHook = () => {
    const hasFamilyFoldersFeature = useSelector(getFamilyFoldersFeature);
    const hasFamilyAlbumsFeature = useSelector(getFamilyAlbumsFeature);

    return hasFamilyFoldersFeature && hasFamilyAlbumsFeature;
};

export const useFamilyShowPreviewHook = () => {
    const hasFamilyFoldersFeature = useSelector(getFamilyFoldersFeature);
    const hasFamilyAlbumsFeature = useSelector(getFamilyAlbumsFeature);
    const isPaid = useSelector(UserSelectors.isPaidUser);

    if (hasFamilyFoldersFeature && hasFamilyAlbumsFeature) {
        return false;
    }

    const showToFreeUser = familyFeaturePreviewFree && !isPaid;
    const showToPaidUser = familyFeaturePreviewPaid && isPaid;

    return showToFreeUser || showToPaidUser;
};
